import type { AppAnnouncement } from './fetchAppAnnouncements';

export function partitionAnnouncementsByKind(items: AppAnnouncement[]): {
  ops: AppAnnouncement[];
  product: AppAnnouncement[];
} {
  const ops: AppAnnouncement[] = [];
  const product: AppAnnouncement[] = [];
  for (const item of items) {
    if (item.kind === 'product') product.push(item);
    else ops.push(item);
  }
  return { ops, product };
}
